import { BusinessType, CountryList } from "../types";

type BankAccountFieldSet =
  | "PrimaryBankAccountFieldSet"
  | "SecondaryBankAccountFieldSet";

export const getBankAccountI18nKeys = (
  businessType: BusinessType | undefined,
  country: CountryList | undefined,
  fieldSet: BankAccountFieldSet
): { labelKey: string; helperTextKey: string } => ({
  labelKey: getLabelKey(country, businessType),
  helperTextKey: getHelperTextKey(country, businessType, fieldSet),
});

const businessTypeToLabelKey: Partial<Record<BusinessType, string>> = {
  "Sole Proprietorship": "bankAccountName_SoleProp",
  Corporation: "bankAccountName_Corporation",
};

const getLabelKey = (
  country: CountryList | undefined,
  businessType: BusinessType | undefined
): string => {
  // The UK has a particular string for this i18n value
  // that always needs to be returned for the country.
  // Hence this check first
  if (country === "United Kingdom") {
    return "bankAccountName";
  }

  if (!!businessType && businessTypeToLabelKey[businessType] !== undefined) {
    return businessTypeToLabelKey[businessType] as string;
  }

  return "bankAccountName";
};

const businessTypeToHelperTextKey: Partial<Record<BusinessType, string>> = {
  "Sole Proprietorship": "bankAccountName_HelperText_SoleProp",
};
const getHelperTextKey = (
  country: CountryList | undefined,
  businessType: BusinessType | undefined,
  fieldSet: BankAccountFieldSet
): string => {
  if (
    fieldSet === "SecondaryBankAccountFieldSet" &&
    !!businessType &&
    businessTypeToHelperTextKey[businessType] !== undefined
  ) {
    return businessTypeToHelperTextKey[businessType] as string;
  }

  return "bankAccountName_HelperText";
};
